import { OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FirstErrorPipe } from '@fuse/pipes/first-error/first-error.pipe';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcTimeInputComponent = /** @class */ (function () {
    function FcTimeInputComponent(firstErrorPipe, fuseTranslationLoaderService) {
        this.firstErrorPipe = firstErrorPipe;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fixedColor = true;
        this.hasCustomErrors = false;
        this.showLabel = true;
        this.showIcon = true;
        this.placeholder = '';
        this.textCentered = false;
        this.colorTimeIcon = false;
        this.removeSubscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcTimeInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateControlState();
        this.control.valueChanges.pipe(takeUntil(this.removeSubscriptions)).subscribe(function () {
            _this.updateControlState();
            _this.errorMessage = _this.firstErrorPipe.transform(_this.control);
        });
    };
    FcTimeInputComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    FcTimeInputComponent.prototype.updateControlState = function () {
        if (this.control.disabled) {
            return;
        }
        var convertedTime = moment(this.control.value, 'HH:mm:ss');
        this.timeValueIsValid = this.control.valid && this.control.value && this.control.value.length >= 4 && convertedTime.isValid();
        this.colorTimeIcon = this.timeValueIsValid || this.fixedColor;
        if (this.timeValueIsValid) {
            this.control.setValue(convertedTime.format('HH:mm:ss'), { emitEvent: false });
        }
        else if (this.control.value && this.control.value.length) {
            this.control.setErrors({
                INVALID_TIME: true
            });
        }
        else {
            this.control.setValue(null, { emitEvent: false });
        }
    };
    return FcTimeInputComponent;
}());
export { FcTimeInputComponent };
